import currentRouteObj from 'root/src/client/logic/route/selectors/currentRouteObj'
import getRecordIdMod from 'root/src/client/logic/route/util/getRecordIdMod'

export default (state) => {
	const { routeId, routeParams = {} } = currentRouteObj(state)
	const { recordId } = routeParams

	return getRecordIdMod({ recordId, routeId })
}
